
export default {
  props: ['diagram'], // DiagramBoxSerializer
  data () {
    return {
      isLoading: false,
      relatedDiagrams: []
    }
  },
  methods: {
    async addToCart () {
      this.isLoading = true
      await this.$store.dispatch('checkout/addDiagramToCart', { diagram: this.diagram, $gtag: this.$gtag, $matomo: this.$matomo, $bing: this.$bing })
      await this.$store.dispatch('checkout/showAddedToCartModal', { diagram: this.diagram, $backend: this.$backend })
      this.isLoading = false
    }
  }
}
